/**
 *
 * Creates a deferred promise that allows the consumer to resolve and reject
 */
const defer = () => {
  let resolve = null;
  let reject = null;

  const _promise = new Promise((_resolve, _reject) => {
    resolve = _resolve;
    reject = _reject;
  });

  return {
    resolve,
    reject,
    promise: _promise
  };
};
export default defer;